import React from "react";
import { Checkbox, HStack } from "native-base";

const CheckBox = ({ options = [], onChange = () => {}, value = [] }) => {
  return (
    <Checkbox.Group onChange={onChange} value={value}>
      <HStack space={20}>
        {options.map((option) => (
          <Checkbox key={option.value} value={option.value}>
            {option.label}
          </Checkbox>
        ))}
      </HStack>
    </Checkbox.Group>
  );
};

export default CheckBox;
